import {ResourceTypes} from '@/store/modules/upload/upload-file.store';
import {uploadApi} from '@/apis/uploadApi';
import Api from '@/apis/Api';
import Vue from 'vue';
const state = {
  [ResourceTypes.RGB]: {
    selectedImages: [],
    Images: []//File{id:아이디,  name:파일명, size:파일크기, type:파일타입, lastModified:파일마지막수정일 } 파일에 대한 정보
  },
  [ResourceTypes.IR]: {
    selectedImages: [],
    Images: []
  },
  [ResourceTypes.CSV]: {
    selectedFiles: [],
    files: []//{type:파일타입, filename:파일명, fileUrl  등등...}
  }
  // 다른 reportId도 동일하게 설정 가능
};

//값을 받아와서 처리하는 경우 state => resourceType => state.reportId[resourceType].files
const getters = {
  resourceImages: (state) => (resourceType) => state[resourceType].Images,
  selectedImages: (state) => (resourceType) => state[resourceType].selectedImages
};
const mutations = {
  SET_IMAGE(state, {resourceType, images }) {
    console.log('SET_IMAGE', resourceType, resourceType.resourceType, images );

    if (resourceType && state[resourceType]) {
      state[resourceType].Images = images;
      // state[resourceType].files.push(images);
    }
    console.log('SET_IMAGE', state[resourceType] );
  },
  SET_FILE(state, {resourceType, files }) {
    console.log('SET_FILE', resourceType, files );

    if (resourceType && state[resourceType]) {
      state[resourceType].files = files;
      // state[resourceType].files.push(images);
    }
    console.log('SET_FILE', state[resourceType] );
  },
  SELECT_IMAGE(state, {resourceType, imageId }) {
    if (!state[resourceType].selectedImages.includes(imageId)) {
      state[resourceType].selectedImages.push(imageId);
    }
  },
  DESELECT_IMAGE(state, {resourceType, imageId }) {
    state[resourceType].selectedImages = state[resourceType].selectedImages.filter(id => id !== imageId);
  },
  SET_SELECTED_IMAGES(state, {resourceType, imageIds }) {
    state[resourceType].selectedImages = imageIds;
  },
  CLEAR_STATE(state) {
    Object.keys(state).forEach((key) => {
      state[key].selectedImages = [];
      state[key].Images = [];
      state[key].selectedFiles = [];
      state[key].files = [];
    });
  },
  CLEAR_SELECTED_FILES(state, {resourceType}) {
    if(resourceType == ResourceTypes.CSV){
      Vue.set(state[ResourceTypes.CSV], 'selectedFiles', []);
    }else Vue.set(state[resourceType], 'selectedImages', []);

  }
};
const actions = {

  clearStates({commit}) {
    commit('CLEAR_STATE');
  },
  async init({ commit }, {resourceType, reportId, currentPage} ) {
    console.log('테스트 reportId:', reportId, resourceType);
    let url;
    let res;
    if(resourceType == ResourceTypes.RGB){
      url = '/api/solarRgbImages/search/byReport';
      res = await uploadApi.get(url, {
        params: {
          solarExamineReport : reportId
        }
      });
    }
    if(resourceType == ResourceTypes.IR){
      url = '/api/solarThermalImages/search/byReport';
      res = await uploadApi.get(url, {
        params: {
          solarExamineReport : reportId
        }
      });
    }
    if(resourceType == ResourceTypes.CSV){
      url = '/api/solarThermalFiles/search/byReport';
      res = await uploadApi.get(url, {
        params: {
          solarExamineReport : reportId,
          page:currentPage,
          size:10,
          sort: 'ID,DESC'
        }
      });
    }

    if(resourceType == ResourceTypes.CSV){
      const files = res?.data._embedded?.solarThermalFiles;
      commit('SET_FILE', {resourceType, files });
    }
    if(resourceType == ResourceTypes.RGB){
      const images = res?.data._embedded?.solarRgbImages;
      commit('SET_IMAGE', {resourceType, images });
    }
    if(resourceType == ResourceTypes.IR){
      const images = res.data?._embedded?.solarThermalImages;
      commit('SET_IMAGE', {resourceType, images });
    }
    return res;
    //테스트용
    // const resp = await fetch('https://picsum.photos/v2/list?page=0&limit=100');
    // const images2 = await resp.json();
    // console.log("resourceType images",resourceType, images2);
    // commit('SET_IMAGE', {resourceType, images2 });
  },
  async clearSelectedImages({ commit }, {resourceType, selectedArr}) {
    //선택된 이미지key값을 받아와서 각각 삭제 -> 삭제api, 새로고침
    const failedDeletes = [];// 삭제실패한 이미지 key값들을 받아서 처리

    if(selectedArr.length > 0){
      if(resourceType == ResourceTypes.RGB){
        for (const imageKey of selectedArr) {
          try {
            await Api.delete(`/solarRgbImages/${imageKey}`);
          } catch (e) {
            console.error(`Failed to delete image with key ${imageKey}:`, e);
            failedDeletes.push(imageKey);
          }
        }
      } else if (resourceType == ResourceTypes.IR) {
        for (const imageKey of selectedArr) {
          try {
            await Api.delete(`/solarThermalImages/${imageKey}`);
          } catch (e) {
            console.error(`Failed to delete image with key ${imageKey}:`, e);
            failedDeletes.push(imageKey);
          }
        }
      } else if (resourceType == ResourceTypes.CSV) {
        for (const fileKey of selectedArr) {
          try {
            await Api.delete(`/solarThermalFiles/${fileKey}`);
          } catch (e) {
            console.error(`Failed to delete image with key ${fileKey}:`, e);
            failedDeletes.push(fileKey);
          }
        }
      }
      commit('CLEAR_SELECTED_FILES', {resourceType});
      console.log('테스트 파일삭제완료 api', failedDeletes);
      if(failedDeletes.length > 0){
        return failedDeletes;
      }else return undefined;
    }
    return undefined;
  },
  async clearAllFiles({ commit }, {reportId, resourceType}) {
    console.log('테스트 전체파일 삭제 :' , reportId, resourceType);
    const failedDeletes = [];// 삭제실패한 이미지 key값들을 받아서 처리
    if(resourceType == ResourceTypes.RGB){
      try {
        await Api.delete(`/solarRgbImages/reportId/${reportId}`);
      } catch (e) {
        console.error('Failed to delete image :', e);
        failedDeletes.push(e);
      }
    } else if (resourceType == ResourceTypes.IR) {
      try {
        await Api.delete(`/solar-thermal-images/reportId/${reportId}`);
      } catch (e) {
        console.error('Failed to delete image :', e);
        failedDeletes.push(e);
      }
    } else if (resourceType == ResourceTypes.CSV) {
      try {
        await Api.delete(`/solarThermalFiles/reportId/${reportId}`);
      } catch (e) {
        console.error('Failed to delete image', e);
        failedDeletes.push(e);
      }
    }
    commit('CLEAR_SELECTED_FILES', {resourceType});
    if(failedDeletes.length > 0){
      return failedDeletes;
    }else return undefined;
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
